import { ExternalLink } from "../withLink";
import Button from "../Button";
import type { Action } from "./shared";

interface SecondaryActionProps {
  secondaryAction?: Action;
  onDismiss?: () => void;
}

const SecondaryAction = ({ secondaryAction, onDismiss }: SecondaryActionProps) => {
  if (!secondaryAction) return null;

  if (secondaryAction.isDismiss) {
    return (
      <Button variant="text" onClick={onDismiss} type="button">
        {secondaryAction.label}
      </Button>
    );
  }

  if (secondaryAction.link) {
    return (
      <ExternalLink href={secondaryAction.link}>
        <p className="text-label-large text-sys-brand-on-surface underline underline-offset-2">
          {secondaryAction.label}
        </p>
      </ExternalLink>
    );
  }

  if (secondaryAction.onClick) {
    return (
      <Button variant="text" onClick={secondaryAction.onClick} type="button">
        {secondaryAction.label}
      </Button>
    );
  }

  return null;
};

export default SecondaryAction;
